import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { DataTable, StatusBadge } from "@/components/kit";
import { useApi, dt, label } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function DeviceLogs({ id, onClose }) {
  const { can } = useAuth();
  const { data } = useApi(id ? `/devices/${id}/logs` : null, {});
  return (
    <Dialog open={!!id} onOpenChange={onClose}>
      <DialogContent className="max-w-3xl bg-card" data-testid="device-logs-dialog">
        <DialogHeader><DialogTitle>Device logs — <span className="font-mono">{data?.device?.device_code}</span></DialogTitle></DialogHeader>
        <Tabs defaultValue="cmd">
          <TabsList>
            <TabsTrigger value="cmd">Commands</TabsTrigger>
            {can("view_technical") && <TabsTrigger value="hb" data-testid="device-logs-tech-tab">Technical / heartbeat</TabsTrigger>}
            <TabsTrigger value="chk">Checks</TabsTrigger>
          </TabsList>
          <div className="mt-3 max-h-[55vh] overflow-y-auto">
            <TabsContent value="cmd"><DataTable testid="device-commands-table" rows={data?.commands} columns={[
              { key: "at", label: "Time", render: (r) => dt(r.at, { second: "2-digit" }) }, { key: "action", label: "Action" },
              { key: "by", label: "By" }, { key: "plate", label: "Plate" }, { key: "manual", label: "Manual", render: (r) => (r.manual ? "YES" : "") },
              { key: "response", label: "Response", render: (r) => <span className="font-mono text-xs">{r.response}</span> }]} /></TabsContent>
            <TabsContent value="hb"><DataTable testid="device-heartbeats-table" rows={data?.heartbeats} empty="No state changes (heartbeat continuous)" columns={[
              { key: "at", label: "Time", render: (r) => dt(r.at, { second: "2-digit" }) }, { key: "event", label: "Event", render: (r) => label(r.event) },
              { key: "prev", label: "From", render: (r) => <StatusBadge status={r.prev} /> }, { key: "new", label: "To", render: (r) => <StatusBadge status={r.new} /> },
              { key: "by", label: "By" }, { key: "note", label: "Note" }]} /></TabsContent>
            <TabsContent value="chk"><DataTable testid="device-checks-table" rows={data?.checks} columns={[
              { key: "due_at", label: "Due", render: (r) => dt(r.due_at) }, { key: "check_type", label: "Type", render: (r) => label(r.check_type) },
              { key: "status", label: "Status", render: (r) => <StatusBadge status={r.status} /> }, { key: "comment", label: "Comment" }]} /></TabsContent>
          </div>
        </Tabs>
      </DialogContent>
    </Dialog>
  );
}
